module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-de.6dc00966.png";